import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

function ScrollToTop() {
  const location = useLocation();
  const { pathname, state } = location;
  const navType = useNavigationType();

  useEffect(() => {
    // If we are opening a modal (background state exists), don't scroll the background
    if (state?.background) return;

    // Industry Standard:
    // Only scroll to top on PUSH (new click) or REPLACE (redirect)
    if (navType !== "POP") {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
  }, [pathname, navType, state]);

  return null;
}

export default ScrollToTop;
